import { render, staticRenderFns } from "./Pagamento.vue?vue&type=template&id=0fe0cd03"
import script from "./Pagamento.vue?vue&type=script&lang=js"
export * from "./Pagamento.vue?vue&type=script&lang=js"
import style0 from "./Pagamento.vue?vue&type=style&index=0&id=0fe0cd03&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports